import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiWhatsApp = () => {
 const { auth } = contextApp();

 const WhatsAppApi = axios.create({
  baseURL: urls.whatsapp(),
  headers: { 'x-access-token': auth?.token }
 });

 /* const getSetting = async (query = null) => (await SettingApi.get(`/${company}`, { params: query })).data; */

 const newBot = async newBot => (await WhatsAppApi.post('/', newBot)).data;

 const getBot = async name => (await WhatsAppApi.get(`/${name ? name : ''}`)).data;

 const logout = async bot => (await WhatsAppApi.get(`/logout/${bot}`)).data;

 const getBots = async () => (await WhatsAppApi.get('/')).data;

 const deletBot = async name => (await WhatsAppApi.delete('/' + name)).data;

 /* const changeCompany = async id => (await WhatsAppApi.get('/change/' + id)).data;

 const updateCompany = async newCompany => (await WhatsAppApi.patch('/', newCompany)).data;

 const createCompany = async newCompany => (await WhatsAppApi.post('/', newCompany)).data;

 const registerCompany = async newCompany => (await WhatsAppApi.post('/register', newCompany)).data; */
 return { newBot, getBot, getBots, logout, deletBot };
};
